import { getColours } from "../api/apimethods";
import { IPetColorModel } from "../typings/models/PetColorModel";

//let colourOptions: IPetColorModel[] = [];

const fetchColoursOption = async () => {
    try {
      const response = await getColours();
      // Process the response data and create the colours options array
      const colourOptions = response.data;
      return colourOptions;
    } catch (error) {
      console.error("Error fetching colours:", error);
      return [];
    }
  };
  
  
  export default fetchColoursOption;